import React from 'react';
import { Input } from 'antd';
import styled from 'styled-components';

interface IAddNewEmailCpaInputProps {
  value?: string;
  onChange?: (value: string) => void;
}

const AddNewEmailCpaInput = ({ value, onChange }: IAddNewEmailCpaInputProps) => {
  const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };
  return <StyledAddNewEmailCpaInput value={value} onChange={handleChangeEmail} placeholder='Please enter email...' />;
};

export default AddNewEmailCpaInput;

const StyledAddNewEmailCpaInput = styled(Input)`
  height: 56px;
  border-radius: 4px;
  flex: 1;
  input {
    color: #1D2129;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  &::placeholder {
    color: #64748B;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
  }
`;
